import React from 'react'
import { Message } from 'semantic-ui-react'
// Local
import { REVIEW, shouldRenderReskin2025 } from '../../../constant'
import If from '../../common/if'
import ReveleerCoachingBox from '../../ReveleerCoachingBox'

/**
 * Provides a component that renders and encounter review warning
 * @param review Encounter review entity
 * @param mode Render mode. Default: left
 */

type Props = {
  mode: string | undefined | null
  review: any
}

function EncounterReviewWarning(
  props: Props
): JSX.Element | null {
  const {
    mode: modeProp = 'left',
    review
  } = props
  if (modeProp !== 'left') return null
  if (review && review.reviewCode === REVIEW.CODE.OPEN) {
    return (
      <>
        <If isTrue={ !shouldRenderReskin2025 }>
          <Message
            error
            className="cdi">
            This patient has not yet been reviewed by the CDI Team
          </Message>
        </If>
        <If isTrue={ shouldRenderReskin2025 }>
          <ReveleerCoachingBox
            coachingBoxType="error"
            isShowing
            message={
              <p>
                This patient has not yet been reviewed by the CDI Team
              </p>
            }
          />
        </If>
      </>
    )
  }
  return null
}

export default EncounterReviewWarning
